<template>
    <div
        v-if="contest"
        class="prizes-page"
    >
        <contests-contest-page-template
            v-if="parsedPrizeContent"
            title="Prizes"
            :content="contest.prizes_content"
        >
            <div
                class="mx-auto"
                style="max-width: 700px;"

            >
                <div
                    class="grid grid-cols-2 gap-4"
                >
                    <prize-card
                        type="grandPrize"
                        class="col-span-1 mb-10"
                    >
                        <template #title>
                            GRAND PRIZE
                        </template>
                        <template #images>
                            <img
                                class="mx-auto"
                                :src="parsedPrizeContent.grandPrizes[0].image"
                            />
                        </template>
                        <div>
                            <div
                                v-html="parsedPrizeContent.grandPrizes[0].content"
                            />
                            <div>
                                {{ parsedPrizeContent.grandPrizes[0].priceText }}
                            </div>
                        </div>
                    </prize-card>
                    <prize-card
                        class="col-span-1 mb-10"
                        type="runnerUp"
                    >
                        <template #title>
                            RUNNER-UP
                        </template>
                        <template #images>
                            <img
                                class="mx-auto"
                                :src="parsedPrizeContent.grandPrizes[1].image"
                            />
                        </template>
                        <div>
                            <div
                                v-html="parsedPrizeContent.grandPrizes[1].content"
                            />
                            <div>
                                {{ parsedPrizeContent.grandPrizes[1].priceText }}
                            </div>
                        </div>
                    </prize-card>

                    <prize-card
                        v-for="prize in parsedPrizeContent.prizes"
                        class=" mb-10"
                    >
                        <template #title>
                            {{ prize.title }}
                        </template>
                        <template #images>
                            <img
                                class="mx-auto"
                                :src="prize.image"
                            />
                        </template>
                        <div>
                            <div v-html="prize.content" />
                            <div>
                                {{ prize.priceText }}
                            </div>
                        </div>
                    </prize-card>
                </div>
            </div>
        </contests-contest-page-template>
    </div>
</template>
<script>
import ContestsContestPageTemplate from "@/js/components/contests/ContestsContestPageTemplate";
import {ENV_URL} from "../../environment";
import PrizeCard from "./PrizeCard";

export default {
    components: {
        PrizeCard,
        ContestsContestPageTemplate,
    },
    data () {
        return {
            parsedPrizeContent: null,
        }
    },
    computed: {
        contest() {
            return this.$store.state.contest;
        },
    },
    mounted() {
        const uri = ENV_URL + this.$route.path;
        this.$store.dispatch('GET_CONTEST_PAGE', {uri});
        let prizesContent = this.contest.prizes_content;
        let el = document.createElement('div');
        el.innerHTML = prizesContent;
        this.parsedPrizeContent = JSON.parse(el.firstChild.wholeText);
    },
}
</script>
<style>
.prizes-page .card {
    display: none;
}
</style>
